import { useLang } from "../i18n/LanguageContext";
import { FadeUp } from "../components/motion";
import { SEO } from "../components/SEO";
import RichText from "../components/RichText";

// Trame commune aux pages légales (politique de confidentialité, conditions d'utilisation)
export function LegalPage({ base, path, testid }) {
  const { t, ts } = useLang();
  const sections = t(`${base}.sections`) || [];
  return (
    <div data-testid={testid} className="pt-32 pb-28">
      <SEO title={ts(`${base}.seo_title`)} description={ts(`${base}.seo_desc`)} path={path} />
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <p className="text-gold tracking-[0.3em] uppercase text-xs mb-4">{t(`${base}.kicker`)}</p>
          <h1 className="font-serif text-5xl md:text-6xl leading-tight mb-4">{t(`${base}.title`)}</h1>
          <p className="text-ivory/65 text-sm mb-14" data-testid={`${testid}-updated`}>{t(`${base}.updated`)}</p>
        </FadeUp>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <FadeUp key={i} delay={Math.min(i * 0.06, 0.4)}>
              <section data-testid={`${testid}-section-${i}`}>
                <h2 className="font-serif text-2xl text-champagne mb-3"><RichText text={s.h} path={`${base}.sections.${i}.h`} /></h2>
                {s.p && <p className="text-ivory/70 text-sm leading-relaxed"><RichText text={s.p} path={`${base}.sections.${i}.p`} /></p>}
                {s.items && (
                  <ul className="list-disc pl-5 mt-2 space-y-1.5 text-ivory/70 text-sm leading-relaxed">
                    {s.items.map((it, j) => <li key={j}><RichText text={it} path={`${base}.sections.${i}.items.${j}`} /></li>)}
                  </ul>
                )}
              </section>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
